import React, { useState, useEffect } from 'react';

const Statistics = () => {
  const [statistics, setStatistics] = useState({
    totalIncome: 0,
    totalExpense: 0,
    totalProfit: 0,
    totalSales: 0,
    totalPurchases: 0,
    netProfit: 0
  });

  useEffect(() => {
    // 从localStorage加载所有数据并计算统计信息
    const calculateStatistics = () => {
      // 加载账单数据
      const bills = JSON.parse(localStorage.getItem('bills') || '[]');
      // 加载出货账单数据
      const sales = JSON.parse(localStorage.getItem('sales') || '[]');
      // 加载进货账单数据
      const purchases = JSON.parse(localStorage.getItem('purchases') || '[]');

      // 计算总收入和总支出
      const totalIncome = bills
        .filter(bill => bill.type === 'income')
        .reduce((sum, bill) => sum + bill.amount, 0);

      const totalExpense = bills
        .filter(bill => bill.type === 'expense')
        .reduce((sum, bill) => sum + bill.amount, 0);

      // 计算总利润（收入 - 支出）
      const totalProfit = totalIncome - totalExpense;

      // 计算总销售额
      const totalSales = sales.reduce((sum, sale) => sum + sale.total, 0);

      // 计算总进货额
      const totalPurchases = purchases.reduce((sum, purchase) => sum + purchase.total, 0);

      // 计算净利润（销售额 - 进货额）
      const netProfit = totalSales - totalPurchases;

      setStatistics({
        totalIncome,
        totalExpense,
        totalProfit,
        totalSales,
        totalPurchases,
        netProfit
      });
    };

    calculateStatistics();
  }, []);

  return (
    <div className="statistics">
      <h2>统计分析</h2>
      <div className="stats-cards">
        <div className="stat-card">
          <h3>总收入</h3>
          <p className="amount income">¥{statistics.totalIncome.toFixed(2)}</p>
        </div>
        <div className="stat-card">
          <h3>总支出</h3>
          <p className="amount expense">¥{statistics.totalExpense.toFixed(2)}</p>
        </div>
        <div className="stat-card">
          <h3>利润</h3>
          <p className={`amount ${statistics.totalProfit >= 0 ? 'income' : 'expense'}`}>
            ¥{statistics.totalProfit.toFixed(2)}
          </p>
        </div>
        <div className="stat-card">
          <h3>总销售额</h3>
          <p className="amount income">¥{statistics.totalSales.toFixed(2)}</p>
        </div>
        <div className="stat-card">
          <h3>总进货额</h3>
          <p className="amount expense">¥{statistics.totalPurchases.toFixed(2)}</p>
        </div>
        <div className="stat-card">
          <h3>净利润</h3>
          <p className={`amount ${statistics.netProfit >= 0 ? 'income' : 'expense'}`}>
            ¥{statistics.netProfit.toFixed(2)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Statistics;